import { usePostHog } from "posthog-js/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import content_my from "./content_my.json";
import {
  CardContainer,
  CardImage,
  CardListContainer,
  CardText,
  CardTextContainer,
  GridContainerStyled,
  TaglineContainer,
  TaglineTitle,
} from "./styles";

export default function FreeStrength() {
  const [solutions, setSolutions] = useState([]);
  const [solutionsCard, setSolutionsCard] = useState([]);

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    const response = content_my;

    const { advantageTitle, advantageSection } = response || {};
    setSolutions(advantageTitle);
    setSolutionsCard(advantageSection);
  }

  const buttonCTA = "Claim my free post";
  const buttonColour = "yellow";
  const posthog = usePostHog();

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      <TaglineContainer>
        <TaglineTitle
          dangerouslySetInnerHTML={{ __html: solutions }}
        ></TaglineTitle>
      </TaglineContainer>

      <CardContainer>
        {solutionsCard?.map((cards, cardIndex) => {
          const imageUrl = cards?.image?.data?.attributes?.url;

          return (
            <>
              <CardListContainer key={cardIndex} cardNumber={cardIndex}>
                <CardImage src={imageUrl} alt={cards?.title || "Card Image"} />

                <CardTextContainer>
                  <CardText
                    type={"title"}
                    cardNumber={cardIndex}
                    dangerouslySetInnerHTML={{ __html: cards?.title }}
                  ></CardText>
                </CardTextContainer>
              </CardListContainer>
            </>
          );
        })}
      </CardContainer>
    </GridContainerStyled>
  );
}
